import imageLinks from "assets/images";
import { ReactSVG } from "react-svg";
import "./PermissionDeniedToast.scss";

const PermissionDeniedToast = ({ visible, onDismiss }) => {
    if (!visible) {
        return null;
    }

    return (
        <div
            className='permission-denied-toast'
            role='status'
            aria-live='polite'
            onClick={onDismiss}>
            <div className='permission-denied-toast__icon'>
                <ReactSVG src={imageLinks.icons?.info} />
            </div>
            <div className='permission-denied-toast__content'>
                <p className='permission-denied-toast__title'>
                    You don&apos;t have permission for this action
                </p>
                <p className='permission-denied-toast__subtitle'>
                    Ask your workspace admin to update your role.
                </p>
            </div>
            <button
                type='button'
                className='permission-denied-toast__dismiss'
                aria-label='Dismiss'
                onClick={(event) => {
                    event.stopPropagation();
                    onDismiss();
                }}>
                <ReactSVG src={imageLinks.icons?.darkCancel} />
            </button>
        </div>
    );
};

export default PermissionDeniedToast;
